export const idSanitize = (uri) => {
  return uri.replace('/api/users/', '')
}
export const idSanitizeDiagnostics = (uri) => {
  return uri.replace('/api/diagnostics/', '')
}

export const idSanitizeUdderHealthTasks = (uri) => {
  return uri.replace('/api/udder_health_tasks/', '')
}

export const idSanitizeGroups = (uri) => {
  return uri.replace('/api/groups/', '')
}
